import { ThemeProvider } from "@mui/material";

import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import BaseGraph from "./BaseGraph";

import { table2Theme } from "../styles/Table2";

const uomFactor = 1;

const records = [
  {
    party: "Winfield Solutions LLC",
    subParty: "Winfield (IN/OH/MI)",
    year1: 7045,
    year2: 46220,
    year3: 0,
    year4: 0,
  },
  {
    party: "Winfield Solutions LLC",
    subParty: "Winfield (Iowa)",
    year1: 503,
    year2: 0,
    year3: 0,
    year4: 0,
  },
  {
    party: "Winfield Solutions LLC",
    subParty: "Aspinwall Cooperative Company",
    year1: 0,
    year2: 64,
    year3: 5491,
    year4: 4969,
  },
];

const rows = records.reduce((acc: any, record: any) => {
  if (!acc[record.party]) {
    acc[record.party] = [];
  }

  acc[record.party].push(record);

  return acc;
}, {});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const AccountTable = () => {
  const infoMessage = (
    <>
      Filter criteria: Customer Name, Modes, Industry, Cities, States
      <br />
      {/* UOM: {uom} */}
    </>
  );

  const body = (
    <ThemeProvider theme={table2Theme}>
      <TableContainer
        // component={Paper}
        style={{ maxHeight: 190, overflowY: "auto" }}
        sx={{ boxShadow: "none" }}
      >
        <Table stickyHeader size="small" aria-label="a dense table">
          <TableHead>
            <TableRow className="Header">
              <TableCell>Account name</TableCell>
              <TableCell>2021</TableCell>
              <TableCell>2022</TableCell>

              <TableCell>2023</TableCell>
              <TableCell>2024</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            id="tablebody"
            style={{ overflowY: "scroll", cursor: "pointer" }}
          >
            {rows &&
              Object.keys(rows).length > 0 &&
              Object.keys(rows).map((key) => {
                const data = rows[key];

                const totals = data.reduce(
                  (acc: any, r: any) => {
                    acc.year1 += r.year1;
                    acc.year2 += r.year2;
                    acc.year3 += r.year3;
                    acc.year4 += r.year4;
                    return acc;
                  },
                  { year1: 0, year2: 0, year3: 0, year4: 0 }
                );

                return (
                  <>
                    <TableRow
                      key={key}
                      style={{
                        fontWeight: 700,
                        color: "#595959",
                        backgroundColor: "#F9F9F9",
                      }}
                    >
                      <TableCell>{key}</TableCell>

                      <TableCell>
                        {Math.round(totals.year1 * uomFactor).toLocaleString(
                          "en",
                          {
                            useGrouping: true,
                          }
                        )}
                      </TableCell>
                      <TableCell>
                        {Math.round(totals.year2 * uomFactor).toLocaleString(
                          "en",
                          {
                            useGrouping: true,
                          }
                        )}
                      </TableCell>
                      <TableCell>
                        {Math.round(totals.year3 * uomFactor).toLocaleString(
                          "en",
                          {
                            useGrouping: true,
                          }
                        )}
                      </TableCell>
                      <TableCell>
                        {Math.round(totals.year4 * uomFactor).toLocaleString(
                          "en",
                          {
                            useGrouping: true,
                          }
                        )}
                      </TableCell>
                    </TableRow>
                    {data.map((r: any, i: number) => (
                      <TableRow
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${key}${i}`}
                        style={{ fontWeight: 400, color: "#595959" }}
                      >
                        <TableCell style={{ paddingLeft: 20 }}>
                          {r.subParty}
                        </TableCell>

                        <TableCell>
                          {Math.round(r.year1 * uomFactor).toLocaleString(
                            "en",
                            {
                              useGrouping: true,
                            }
                          )}
                        </TableCell>
                        <TableCell>
                          {Math.round(r.year2 * uomFactor).toLocaleString(
                            "en",
                            {
                              useGrouping: true,
                            }
                          )}
                        </TableCell>
                        <TableCell>
                          {Math.round(r.year3 * uomFactor).toLocaleString(
                            "en",
                            {
                              useGrouping: true,
                            }
                          )}
                        </TableCell>
                        <TableCell>
                          {Math.round(r.year4 * uomFactor).toLocaleString(
                            "en",
                            {
                              useGrouping: true,
                            }
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </ThemeProvider>
  );

  return (
    <BaseGraph
      // loading={loading}
      loading={false}
      title="BY ACCOUNT"
      infoMessage={infoMessage}
      height={200}
    >
      {body}
    </BaseGraph>
  );
};

export default AccountTable;
